import React from "react";

import pauseIcon from "../../Images/pause-icon.svg";
import playIcon from "../../Images/play-icon.svg";
import resetIcon from "../../Images/reset-icon.svg";

export default function CounterHeader({
  isRunning,
  onToggleTimer,
  onResetTimer,
  spentTime,
  onTapFeedback,
}) {
  // -------------------------
  // Handlers
  // -------------------------
  const handleToggle = () => {
    onTapFeedback?.();
    onToggleTimer();
  };

  const handleReset = () => {
    onTapFeedback?.();
    onResetTimer();
  };

  // -------------------------
  // Render
  // -------------------------
  return (
    <div className="counterWrapper__header">
      <div className="counterWrapper__header-nav">
        {/* Start / Pause */}
        <span
          className="start-stop-btn"
          onClick={handleToggle}
          role="button"
          aria-label={isRunning ? "Pause timer" : "Start timer"}
        >
          <img
            alt=""
            src={isRunning ? pauseIcon : playIcon}
          />
        </span>

        {/* Time */}
        <span
          className="time"
          aria-label={`Elapsed time ${spentTime}`}
        >
          {spentTime}
        </span>

        {/* Reset */}
        <span
          className="time-reset-btn"
          onClick={handleReset}
          role="button"
          aria-label="Reset timer"
        >
          <img alt="" src={resetIcon} />
        </span>
      </div>
    </div>
  );
}